import { render, staticRenderFns } from "./Aldursrod.vue?vue&type=template&id=1133f0a6&scoped=true&"
import script from "./Aldursrod.vue?vue&type=script&lang=js&"
export * from "./Aldursrod.vue?vue&type=script&lang=js&"
import style0 from "./Aldursrod.vue?vue&type=style&index=0&id=1133f0a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1133f0a6",
  null
  
)

export default component.exports